import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export function checkEmailChangedRule(initialEmail?: string): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const emailReceipt = control.get('emailReceipt')!.value;
		const emailSendTimestamp = control.get('emailSendTimestamp')!.value;
		return !!initialEmail && emailReceipt !== initialEmail && emailSendTimestamp ? { checkEmailChangedFlag: true } : null;
	};
}
